<template>
  <a-modal
    centered
    title="更换桌台"
    v-model="visible"
    @cancel="visible = false"
    @ok="onSubmit"
    :maskClosable="false"
    :confirmLoading="loading"
    width="800px"
  >
    <div class="change-box">
      <a-radio-group
        v-model="sourceTableId"
        class="use-table"
        v-if="useingTable && useingTable.length > 1"
        s
      >
        <a-radio
          :style="radioStyle"
          v-for="item in useingTable"
          :value="item.TableId"
          :key="item.TableId"
        >
          {{ item.TableName }}
        </a-radio>
      </a-radio-group>
      <div
        v-if="emptyTables && emptyTables.length"
        class="open-table-list item-box"
      >
        <div
          v-for="item in emptyTables"
          :key="item.TableId"
          class="open-table-item"
          @click="onSelected(item)"
          :class="[
            {
              checked: selectedKey == item.TableId
            }
          ]"
        >
          <div class="item-title tc">
            {{ item.TableName }}
          </div>
          <a-icon type="check" class="check-icon" />
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      selectedKey: "",
      orderId: "",
      sourceTableId: "",
      loading: false,
      emptyTables: [],
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px"
      },
      useingTable: []
    };
  },
  created() {},
  methods: {
    show(orderId, useingTable) {
      this.visible = true;
      this.orderId = orderId;
      this.selectedKey = "";
      this.useingTable = useingTable;
      this.sourceTableId = useingTable[0].TableId;
      this.getTables();
    },
    getTables() {
      return new Promise((resolve, reject) => {
        this.$post("RMS_GetTableStatus", {
          ShowForbiddens: false
        })
          .then(res => {
            this.emptyTables = res.Data.TableStatusDetails.filter(
              el => el.Status == 1
            );
            this.selectedKey = this.emptyTables[0].TableId;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    onSelected(item) {
      const { selectedKey } = this;
      if (selectedKey == item.TableId) {
        this.selectedKey = "";
      } else {
        this.selectedKey = item.TableId;
      }
    },
    onCancel() {
      this.visible = false;
    },
    onSubmit() {
      const { $post, selectedKey } = this;
      if (!selectedKey) {
        this.$message.warning("请选择更换的目标桌台");
        return false;
      }
      this.loading = true;
      $post("RMS_ChangeTable", {
        OrderId: this.orderId,
        SourceTableId: this.sourceTableId,
        TargetTableId: selectedKey
      })
        .then(() => {
          this.loading = false;
          this.$message.success("更换成功");
          this.$emit("update", selectedKey);
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.item-box {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  & > label {
    min-width: 100px;
    text-align: right;
    font-size: 16px;
  }
}
.open-table-list {
  overflow: hidden;
  overflow-y: auto;
  // border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  margin-bottom: 10px;

  .open-table-item {
    background-color: #fff;
    width: 90%;
    height: 50px;
    margin: 3px auto;
    border-radius: 2px;
    padding: 6px;
    cursor: pointer;
    float: left;
    border: 1px solid #ddd;
    .item-title {
      font-size: 18px;
      padding-top: 5px;
    }
    &:hover {
      box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
    }
    .check-icon {
      display: none;
    }
    &.checked {
      border: 1px solid #f20;
      position: relative;
      &::after {
        content: "";
        width: 0;
        height: 0;
        border-bottom: 18px solid #f20;
        border-left: 20px solid transparent;
        position: absolute;
        bottom: 0;
        right: 0;
      }
      .check-icon {
        display: block;
        position: absolute;
        top: initial;
        bottom: 0;
        left: initial;
        right: 0;
        font-size: 10px;
        z-index: 10;
        color: #fff;
      }
    }
  }
}
.table-select-list {
  height: calc(100vh - 170px);

  .open-table-item {
    width: 31.3%;
    margin: 1%;
  }
}
.change-box {
  display: flex;
  .use-table {
    min-width: 200px;
    padding: 10px;
    background: #fafafa;
  }
}
</style>
